import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {
  Container,
  RowContainer,
  ContainerItemType,
  UnderlineItemType,
  SegmentedItemContent,
  SegmentedLabelRow,
  SegmentedInfoButton,
} from './styled'
import { P } from 'views/components/UI/Text/'

interface ItemOptionProps {
  name: string
  focused: string
  setSelected: (value: string) => void
  value: string
  helperText?: string
  appearance?: 'default' | 'segmented'
}

const ItemOption = (props: ItemOptionProps) => {
  const { name, focused, setSelected, value, helperText, appearance = 'default' } = props
  const isFocused = focused === value
  const isSegmented = appearance === 'segmented'

  return (
    <ContainerItemType
      $appearance={appearance}
      $focused={isFocused}
      onClick={() => {
        setSelected(value)
      }}
    >
      {isSegmented ? (
        <SegmentedItemContent>
          <SegmentedLabelRow>
            <P color={isFocused ? '#245D7D' : '#647789'} fontWeight={700} margin="0px" fontSize="15px">
              {name}
            </P>
            {helperText ? (
              <Tooltip title={helperText} arrow placement="top">
                <SegmentedInfoButton
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation()
                  }}
                  aria-label={`Ayuda sobre ${name}`}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                </SegmentedInfoButton>
              </Tooltip>
            ) : null}
          </SegmentedLabelRow>
        </SegmentedItemContent>
      ) : (
        <>
          <P color={isFocused ? '#2D749C' : '#707070'} weight={600} paddingBottom={isFocused ? '0' : '7px'}>
            {name}
          </P>
          {isFocused && <UnderlineItemType />}
        </>
      )}
    </ContainerItemType>
  )
}

interface IProps {
  items: Array<{ name: string; value: string; helperText?: string }>
  selected: string
  setSelected: (value: string) => void
  appearance?: 'default' | 'segmented'
}

//Main component
const HorizontalSelector = (props: IProps) => {
  const { items, selected, setSelected, appearance = 'default' } = props

  return (
    <Container $appearance={appearance}>
      <RowContainer justifyContent="center" $appearance={appearance}>
        {items.map((item, index) => {
          return (
            <ItemOption
              key={`item-${index}`}
              name={item.name}
              focused={selected}
              setSelected={setSelected}
              value={item.value}
              helperText={item.helperText}
              appearance={appearance}
            />
          )
        })}
      </RowContainer>
    </Container>
  )
}

export default HorizontalSelector
